<template>
  <div id="project-main" class="main-project" data-aos="zoom-in" data-aos-duration="1500">
    <div class="main-project-row container">
      <MyTitle>
        <template v-slot:title><b style="color: #1E55AE">主要</b>工程</template>
      </MyTitle>
      <el-table
          :data="mainProjectDetail"
          style="width: 100%;margin-bottom: 20px;"
          row-key="id"
          default-expand-all
          height="700"
          :row-class-name="tableRowClassName"
          :tree-props="{children: 'children'}"
          :header-cell-style="{backgroundColor:'#1E55AE', color: 'white', height: '60px'}"
          :header-row-style="{backgroundColor:'#1E55AE'}"
          v-loading="loading" element-loading-text="拼命加载中...">
        <el-table-column
            prop="id"
            label="序号"
            width="250">
        </el-table-column>
        <el-table-column
            prop="title"
            label="项目工程">
        </el-table-column>
        <el-table-column
            prop="capacity"
            label="装机容量"
            width="250">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainProject",
  data() {
    return {
      mainProject: [],
      loading: false,
    }
  },
  computed: {
    mainProjectDetail() {
      const mainProject = this.mainProject
      let data = {}
      const categorizeSet = [...new Set(mainProject.map(item => item.categorize_title))]
      data = categorizeSet.map((item, index) => {
        return {
          id: index + 1,
          title: item,
          children: []
        }
      })

      data.forEach(item1 => {
        let index = 0
        mainProject.forEach(item2 => {
          if (item1.title === item2.categorize_title) {
            item1.children.push({
              id: `${item1.id}.${++index}`,
              title: item2.title,
              capacity: item2.capacity
            })
          }
        })
      })

      return data
    }
  },
  methods: {
    // 获取主要工程数据
    async getMainProject() {
      this.$api.reqMainProject().then(results => {
        if (results.status === 200) {
          this.mainProject = results.results
        } else {
          Promise.reject('error')
        }
      }).catch(() => {
        this.$message({showClose: true, message: "主要工程数据请求失败！", type: "error"})
      }).finally(()=> {
        this.loading = false
      })
    },

    tableRowClassName({row}) {
      if (row.id.toString().indexOf('.') !== -1) {
        return '';
      } else {
        return 'success-row';
      }
    }
  },
  mounted() {
    this.getMainProject()
  }
}
</script>

<style scoped lang="less">
.main-project {
  padding: 80px 0;

  .main-project-row {
  }
}

/deep/ .el-table {
  margin-top: 80px;
  font-size: 16px;
}

</style>

<style lang="less">
.el-table {
  margin-top: 80px;
  font-size: 16px;

  .success-row {
    font-weight: bold;
    background: rgb(198, 226, 255);;
  }
}
</style>